import React, { useRef } from 'react';
import Modal from '../shared/Modal';

const DeleteTenantModal = ({ open, onClose, tenant, onConfirm, isOwner, isLastMember, hasOtherOwners }) => {
    const cancelRef = useRef(null);
    const confirmRef = useRef(null);

    if (!open || !tenant) return null;

    const getWarningMessage = () => {
        if (!isOwner && !isLastMember) {
            return (
                <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
                    <p className="text-sm text-blue-800 dark:text-blue-200">
                        <strong>Quitter l'organisation</strong>
                    </p>
                    <p className="text-sm text-blue-700 dark:text-blue-300 mt-2">
                        Vous allez quitter l'organisation <strong>{tenant.name}</strong>. 
                        Vous perdrez l'accès à tous les messages, todos et paramètres de cette organisation.
                    </p>
                </div>
            );
        }

        if (isOwner && !hasOtherOwners && !isLastMember) {
            return (
                <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
                    <p className="text-sm text-yellow-800 dark:text-yellow-200">
                        <strong>⚠️ Vous êtes le seul propriétaire</strong>
                    </p>
                    <p className="text-sm text-yellow-700 dark:text-yellow-300 mt-2">
                        Vous ne pouvez pas quitter l'organisation car vous êtes le seul propriétaire. 
                        Vous devez d'abord nommer un autre propriétaire dans les paramètres de l'organisation.
                    </p>
                </div>
            );
        }

        if (isLastMember) {
            return (
                <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
                    <p className="text-sm text-red-800 dark:text-red-200">
                        <strong>⚠️ Suppression définitive</strong>
                    </p>
                    <p className="text-sm text-red-700 dark:text-red-300 mt-2">
                        Vous êtes le seul membre de cette organisation. La quitter supprimera définitivement 
                        l'organisation <strong>{tenant.name}</strong> et toutes ses données (messages, todos, etc.).
                    </p>
                    <p className="text-sm text-red-700 dark:text-red-300 mt-2 font-semibold">
                        Cette action est irréversible !
                    </p>
                </div>
            );
        }

        if (isOwner && hasOtherOwners) {
            return (
                <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
                    <p className="text-sm text-blue-800 dark:text-blue-200">
                        <strong>Quitter l'organisation</strong>
                    </p>
                    <p className="text-sm text-blue-700 dark:text-blue-300 mt-2">
                        Vous allez quitter l'organisation <strong>{tenant.name}</strong>. 
                        Un autre propriétaire continuera à gérer l'organisation.
                    </p>
                </div>
            );
        }
        return null;
    };

    const canLeave = !isOwner || hasOtherOwners || isLastMember;
    const actionLabel = isLastMember ? 'Supprimer' : 'Quitter';

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={isLastMember ? "Supprimer l'organisation" : "Quitter l'organisation"}
            actions={
                <>
                    <button
                        ref={cancelRef}
                        onClick={onClose}
                        className="flex-1 px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors font-semibold"
                    >
                        Annuler
                    </button>
                    {canLeave && (
                        <button
                            ref={confirmRef}
                            onClick={onConfirm}
                            className={`flex-1 px-4 py-2 rounded-lg transition-colors font-semibold ${
                                isLastMember 
                                    ? 'bg-red-600 hover:bg-red-700 text-white'
                                    : 'bg-blue-600 hover:bg-blue-700 text-white'
                            }`}
                        >
                            {actionLabel}
                        </button>
                    )}
                </>
            }
            initialFocusRef={canLeave ? confirmRef : cancelRef}
        >
            {getWarningMessage()}
        </Modal>
    );
};

export default DeleteTenantModal;
